import React from 'react';
import { MainLayout } from '../components/MainLayout';

interface UserInfo {
  displayName: string;
  userPrincipalName: string;
  roles: string[];
}

interface DashboardRouteProps {
  userInfo: UserInfo | null;
}

export const DashboardRoute: React.FC<DashboardRouteProps> = ({ userInfo }) => {
  return <MainLayout userInfo={userInfo} />;
};
